import React, { useEffect, useRef, useState } from "react";
import { AirbudsYearlyHeader } from "../component/storyHeader";
import { ValidationBackground } from "./validationBackground";
import { ActionButton, ActionButtonFull } from "../component/buttons";
import { TypeAnimation } from "react-type-animation";

import { motion, animate } from "motion/react";
import { useData } from "../data/dataContext";
import { ComebackMessage } from "../comebackToUnlock";

import { useNavigate } from "react-router";
import { StoryOverlay } from "../compat/compat";
import StoryProgressBar from "../component/pagination";
import { useStateAndRef } from "../intro";

const validationList = [
  "You're ending 2024 proud of all the tracks you listened to! I know you and your music taste brings the life to every party, and I'm sure in 2025 you will keep being authentically you.",
  "You're ending 2024 knowing you played banger after banger the entire year. In 2025, evvvvvveryone is going to want you on aux (if they didn't already).",
  "You're ending 2024 in perfect harmony. You're all about balance, and that is reflected in your music taste. I hope 2025 brings you great peace!",
  "You're ending 2024 shamelessly you. Having niche music taste AND being on a music sharing app is just so cool of you. We will continue to be in awe of you all of 2025 and beyond!",
  "You're ending 2024 being unmistakably you. Your music taste is unique just like you. Don't forget that in 2025 and keep listening to the tracks you hold near to your heart, and no one elses.",
];

const validationGenre = ["BASIC", "POPULAR", "INTERESTING", "NICHE", "OBSCURE"];

export const EmptyScreen = ({ text, closeAction }) => {
  return (
    <div className="content column-layout">
      <p>{text ? text : "This section is empty"}</p>
      <AirbudsYearlyHeader hideMenuBanner={true} closeAction={closeAction} />
    </div>
  );
};
export const Validation = ({}) => {
  const { data } = useData();
  const [validationStep, setValidationStep, refStep] = useStateAndRef(0);

  const navigate = useNavigate();

  if (!data) {
    return (
      <EmptyScreen text="no validation" closeAction={() => navigate("/menu")} />
    );
  }

  const validationCategory = data.validation ? data.validation.category : 0;
  const genre = data.validation ? data.validation.genre : null;
  const genreCategory = validationGenre[validationCategory];
  const validationText = validationList[validationCategory];

  const badgeImage = (function () {
    switch (validationCategory) {
      case 1:
        return require("../assets/img/badge-validation-1.png");
      case 2:
        return require("../assets/img/badge-validation-2.png");
      case 3:
        return require("../assets/img/badge-validation-3.png");
      case 4:
        return require("../assets/img/badge-validation-4.png");
      case 5:
        return require("../assets/img/badge-validation-5.png");
      default:
        return require("../assets/img/badge-validation-1.png");
    }
  })();

  const STEP_COUNT = 5;
  const previous = () => {
    setValidationStep(Math.max(validationStep - 1, 0));
  };

  const next = () => {
    if (validationStep == STEP_COUNT - 1) {
      navigate("/menu");
    } else {
      setValidationStep(Math.min(validationStep + 1, STEP_COUNT));
    }
  };

  const renderState = (state) => {
    switch (state) {
      case 0:
        return (
          <motion.div
            className="app-validation-content"
            key="step-0"
            initial={{ opacity: 0, y: "100%" }}
            animate={{ opacity: 1, y: "0%" }}
            exit={{ opacity: 1, y: "-100%" }}
            transition={{
              duration: 1.0,
              delay: 0.0,
              ease: [0, 0.71, 0.2, 1.01],
            }}
          >
            <TypeAnimation
              className="validation-display"
              sequence={[
                1000,
                "👋",
                1000,
                "You know", //  Continuing previous Text
                750,
                "You know how it goes.",
                1000,
                "Let's stop at the station.",
                1000,
                "What station you may ask?",
                2000,
                () => {
                  if (refStep.currentPage == 0) {
                    setValidationStep(1);
                  }
                },
              ]}
              style={{ fontSize: "2em" }}
              typeSpeed={220}
            />
          </motion.div>
        );
      case 1:
        return (
          <motion.div
            key="step-1"
            className="app-validation-content"
            initial={{ opacity: 0, y: "100%" }}
            animate={{ opacity: 1, y: "0%" }}
            exit={{ opacity: 1, y: "-100%" }}
            transition={{
              duration: 1.0,
              delay: 0.0,
              ease: [0, 0.71, 0.2, 1.01],
            }}
          >
            <div className="validation-title">
              <img
                alt="validation"
                src={require("../assets/img/logo-validation.svg")}
              />
            </div>

            <button onClick={() => setValidationStep(2)}>
              <ActionButtonFull title="tell me about me" />
            </button>
          </motion.div>
        );
      case 2:
        return (
          <motion.div
            key="step-2"
            className="app-validation-content app-validation-result"
            initial={{ opacity: 0, y: "100%" }}
            animate={{ opacity: 1, y: "0%" }}
            exit={{ opacity: 1, y: "-100%" }}
            transition={{
              duration: 1.0,
              delay: 0.0,
              ease: [0, 0.71, 0.2, 1.01],
            }}
          >
            <TypeAnimation
              className="validation-display"
              sequence={[
                1000,
                validationText,
                3000,
                () => {
                  if (refStep.currentPage == 2) {
                    setValidationStep(3);
                  }
                },
              ]}
              style={{ fontSize: "2em" }}
              typeSpeed={220}
            />
          </motion.div>
        );
      case 3:
        return (
          <motion.div
            key="step-3"
            className="app-validation-content app-validation-result"
            initial={{ opacity: 0, y: "100%" }}
            animate={{ opacity: 1, y: "0%" }}
            exit={{ opacity: 1, y: "-100%" }}
            transition={{
              duration: 1.0,
              delay: 0.0,
              ease: [0, 0.71, 0.2, 1.01],
            }}
          >
            {genre && (
              <div className="column-layout validation-header">
                <img alt="validation" src={badgeImage} />

                <h3 className="headline">{genre}</h3>
                <p className="caption">Your top {genreCategory} genre</p>
              </div>
            )}

            <p className="validation-text">{validationText}</p>

            <button onClick={() => setValidationStep(4)}>
              <ActionButton title="Next" />
            </button>
          </motion.div>
        );
      case 4:
        return (
          <ComebackMessage
            featureText=" Come back tomorrow to unlock your next stat: Ghosted & Opposite Artists"
            next={() => {}}
          />
        );
      default:
        return <div></div>;
    }
  };

  return (
    <div className="app-validation-container validation-gradient-background">
      <ValidationBackground showFloatingItems={validationStep < 2} />
      {renderState(validationStep)}
      <StoryOverlay prev={previous} next={next} />
      <AirbudsYearlyHeader
        closeAction={() => {
          navigate("/menu");
        }}
      />

      <StoryProgressBar
        className={"story-bar"}
        totalPages={STEP_COUNT}
        currentPage={validationStep}
        duration={0}
      />
    </div>
  );
};
